module.exports = __webpack_public_path__ + "static/media/ensina-banner-financas-site-02.199bd4f1.png";